<!-- <ng-container *ngIf="!compilation.packingConditions.length || compilation.packingConditions[0].items"> -->


<!-- TODO: find out why right table border is not drawn in wkhtmltopdf ????? -->

<!-- <ngx-loading-spinner *ngIf="!legacy && !print" [loading]="data.boxesAreLoading.length > 0"></ngx-loading-spinner> -->

<ng-container *ngIf="!legacy && palletInfo">

  <div #packingTable  *ngIf="checkValid()" [ngStyle]="{ 'font-size': highlight ? '1.4rem' : (coversheet ? '1rem' : null), 'opacity': compilation.useOldPackingConditions ? '0.4' : null }">

    <!-- <ng-container *ngFor="let li of compilation.lineItems; index as lidx">
      <div *ngIf="!print && !disabled" class="row">
        <div style="padding:0.3rem;"><button class="nrk-doc-button" (click)="addPallet(lidx)">+</button></div>
        <div>Add Pallet to Pos {{lidx}}</div>
      </div>
    </ng-container> -->
    <div *ngIf="!print && !disabled && compilation.packingStatus >= packingStatus.readyForDispatch">
      Not editable as <div style="width:10rem;display:inline-block"><ngx-dn-status [compilation]="compilation"></ngx-dn-status></div>
    </div>

    <div *ngIf="!print" style="padding-left:3rem; margin:0.3rem">
      <ngx-doc-form-checkbox [(value)]="compilation.showPackingPalletsInPdf" label="show pallet details in PDF"></ngx-doc-form-checkbox>
    </div>

    <div *ngIf="!print" class="pt-2">
      <button class="nrk-button ml-3" (click)="removePallets()" [attr.disabled]="isDisabled() || null">Remove All Pallets</button>
    </div>
    <ng-container *ngIf="!print || warehousing || compilation.showPackingPalletsInPdf || coversheet">
      <ng-container *ngFor="let item of compilation.lineItems; index as lidx; last as lastli; first as firstli">

        <div *ngIf="!print && item.finishedProduct?.type === productType.Energy && !item.finishedProduct?.packingSpec?.[0]" class="mt-2" style="background-color: #fd3; padding:0.3rem">
          Missing Final Packing Definition (FPD) in Finished Product {{item.finishedProduct.calcName}} ({{item.finishedProduct.calcCode}})
        </div>
        <div *ngIf="!print && item.finishedProduct?.type === productType.Energy && (item.finishedProduct?.boxLabelPriority === null || item.finishedProduct?.boxLabelPriority === undefined)" class="mt-2" style="background-color: #fd3; padding:0.3rem">
          Missing First Priority of Box Label in Finished Product {{item.finishedProduct.calcName}} ({{item.finishedProduct.calcCode}})
        </div>
        <div *ngIf="!print" style="margin:1rem">
          <span class="ml-2"><b>Pos {{lidx+1}}</b></span>
          <button class="nrk-button ml-3" (click)="wizard.open(item)" [attr.disabled]="!showWizard(lidx) || null">Packing wizard</button>
          <ngx-packing-wizard #wizard [compilation]="compilation" (resultChange)="savePackingWizardData($event, item)" [warehousing]="warehousing"></ngx-packing-wizard>
          <button class="nrk-button ml-3" (click)="addPallet(lidx, true)" [attr.disabled]="isDisabled() || null">Add Pallet</button>
          <span *ngIf="compilation.packingConditions?.length && !compilation.useOldPackingConditions && item.finishedProduct?.type === productType.Energy && getTotalSumPieces(lidx) !== item.quantity" class="ml-4" style="background-color: #f009; padding:0.3rem">
            <b>Different Q on line item and Packing details!</b>
          </span>
        </div>

        <div *ngIf="compilation.packingConditions?.length && warehousing && !compilation.useOldPackingConditions && item.finishedProduct?.type === productType.Energy && getTotalSumPieces(lidx) !== item.quantity" class="ml-4" style="background-color: #f009; padding:0.3rem">
          <b>Different Q on line item and Packing details!</b>
        </div>

        <ng-container *ngFor="let pallet of compilation.packingConditions; index as pidx; first as first">
  
          <ng-container *ngIf="(!print || warehousing || coversheet) && pallet.lineItemIdx === lidx && this.shelfLifeError[pallet.palId]">
            <div class="mt-2" [ngStyle]="{'background-color': print ? '#f003': '#f009', padding: '0.3rem'}">
              Shelf Life &lt; 6 Months
            </div>
          </ng-container>

          <ng-container *ngIf="(!print || warehousing || coversheet) && data && pallet.lineItemIdx === lidx && spoCustomerRefMismatch[lidx]?.length">
            <div *ngFor="let ref of spoCustomerRefMismatch[lidx]" class="mt-2" [ngStyle]="{'background-color': print ? '#f003': '#f009', padding: '0.3rem'}">
              Customer on original box labels: <b>{{data.getBusinessName(ref)}}</b>; DN Recipient: <b>{{data.getBusinessName(compilation.recipient)}}</b>
            </div>
          </ng-container>

          <ng-container *ngIf="palletInfo[pallet.palId]  && pallet.lineItemIdx === lidx && (highlight === undefined || pallet === highlight) && (!coversheet || lineItemIdx === lidx)">

            <div style="page-break-inside:avoid">

              <ng-container *ngIf="['OC', 'PL', 'DN', 'IN', 'PFIN'].includes(typeData.get(compilation.type).code) && first">
          
                <span *ngIf="!data.areBoxesLoading"
                  class="ml-4" style="background-color: #fd3; padding:0.3rem">
                    <b>No packing details have been generated yet!</b>
                </span>
      
                <div *ngIf="checkShelfLife(null, lidx)" class="ml-4" style="background-color: #f009; padding:0.3rem">
                  <b>Shelf life < 6 months: double check with NRKA Admin</b>
                </div>
      
                <!-- <ng-container *ngIf="(!print || warehousing) && data && spoCustomerRefMismatch[lidx]?.length">
                  <div *ngFor="let ref of spoCustomerRefMismatch[lidx]" class="mt-2" style="background-color: #f009; padding:0.3rem">
                    Customer on original box labels: <b>{{data.getBusinessName(ref)}}</b>; DN Recipient: <b>{{data.getBusinessName(compilation.recipient)}}</b>
                  </div>
                </ng-container> -->
              </ng-container>      

              <div *ngIf="warehousing && checkShelfLife(pallet)" class="ml-4" style="background-color: #f009; padding:0.3rem">
                <b>Shelf life < 6 months: double check with NRKA Admin</b>
              </div>
              <div *ngIf="warehousing && getPacking(pallet)?.boxesPerLayer && getPacking(pallet)?.layersPerPallet" style="padding:1rem;">
                <span>Max load per pallet: {{ getPacking(pallet)?.boxesPerLayer }} boxes per layer, {{ getPacking(pallet)?.layersPerPallet }} layers per pallet
                  = max {{getPacking(pallet)?.boxesPerLayer * getPacking(pallet)?.layersPerPallet}} boxes
                </span>
              </div>

              <div class="nrk-table" style="padding:0.5rem">
                <ng-container *ngIf="!print && !isDisabled()">
                  <button class="nrk-button ml-2" (click)="initProductionTable(); palletWiz.open(item)">☰</button>
                  <ngx-packing-wizard #palletWiz [compilation]="compilation" [pallet]="pallet" (resultChange)="savePalletData($event)"></ngx-packing-wizard>
                </ng-container>

                <ng-container *ngIf="warehousing && ocCompilation && compilation.packingStatus === packingStatus.readyForPacking && !disabled">
                  <button class="nrk-button ml-2" (click)="initProductionTable(); palletWiz.open(item)">☰</button>
                  <ngx-packing-wizard #palletWiz [compilation]="ocCompilation" [pallet]="ocPallet(pidx)" (resultChange)="saveWarehousingPalletData($event)" [warehousing]="warehousing"></ngx-packing-wizard>
                </ng-container>

                <button *ngIf="!print && !isDisabled()" class="nrk-doc-button ml-2 mr-2" (click)="removePallet(pallet)" [attr.disabled]="isSaving || null">-</button>
                <b [ngStyle]="{ fontSize: coversheet ? '1.5rem' : null}">
                  <span *ngIf="!highlight" style="padding-left: 1rem">{{palletInfo[pallet.palId]?.palPos}}</span>
                  <span style="padding-left: 1rem">{{palletInfo[pallet.palId]?.dn}}</span>
                </b>
                <span style="padding-left: 2rem">{{pallet.packingType}}:</span>
                <!-- <span *ngIf="!print" style="padding-left:1rem"><ngx-doc-form-dropdown [(value)]="pallet.packingType" [options]="packingTypeOptions[packingForIdx[lidx][0]?.items[0]?.typeOfBox || 'default']" (valueChange)="packingTypeChanged(pallet, $event)" [disabled]="isDisabled()"></ngx-doc-form-dropdown></span>
                <span *ngIf="print" style="padding-left:1rem">{{data.getOptionName(packingTypeOptions[packingForIdx[lidx][0]?.items[0]?.typeOfBox || 'default'], item.packingType)}}</span> -->
                <!-- <span *ngIf="!print && pallet.packingType !== 'manual'" style="padding-left:1rem"><ngx-doc-form-dropdown [(value)]="pallet.packingType" [options]="packingTypeOptions?.[packingForIdx[lidx][pidx]]" (valueChange)="packingTypeChanged(pallet, $event)" [disabled]="pallet.packingType !== 'manual' || isDisabled()"></ngx-doc-form-dropdown></span> -->
                <span *ngIf="pallet.packingType !== 'manual'" style="padding-left:1rem">{{data.getOptionName(packingTypeOptions?.[packingForIdx?.[lidx]?.[pidx]], item.packingType)}}</span>
                <div class="d-inline-block mt-2" *ngIf="!print && pallet.packingType === 'manual'">
                  <div class="ml-4 d-inline-block"><ngx-doc-form-checkbox [(value)]="pallet.temperatureSticker" label="Temperature sticker" [disabled]="isDisabled()"></ngx-doc-form-checkbox></div>
                  <div class="ml-4 d-inline-block"><ngx-doc-form-checkbox [(value)]="pallet.thermoShield" label="Thermo shield" [disabled]="isDisabled()"></ngx-doc-form-checkbox></div>
                  <div class="ml-4 d-inline-block"><ngx-doc-form-checkbox [(value)]="pallet.edgeProtection" label="Edge protection" [disabled]="isDisabled()"></ngx-doc-form-checkbox></div>
                  <div class="ml-4 d-inline-block"><ngx-doc-form-checkbox [(value)]="pallet.relabelling" label="NRKA relabelling" [disabled]="isDisabled()"></ngx-doc-form-checkbox></div>
                  <div class="ml-4 d-inline-block"><ngx-doc-form-texfield [(value)]="pallet.freeText" placeholder="Remark" [disabled]="isDisabled()"></ngx-doc-form-texfield></div>
                </div>              

                <div style="float: right" class="d-inline-block" *ngIf="!print">
                  Height Override: <ngx-doc-form-texfield [value]="pallet.heightOverride" (valueChange)="onHeightOverride(pallet, $event)" [styles]="{width:'2.5rem'}"></ngx-doc-form-texfield>
                </div>
              </div>
    
              <ng-container *ngTemplateOutlet="palletInfoTemplate; context: { pallet }"></ng-container>
    
              <!-- cover sheet check box -->
              <div *ngIf="coversheet" style="position:relative">
                <div style="position:absolute;bottom:0;left:-3rem;width:2rem;height:2rem;border:1px solid gray"></div>
              </div>
    
              <table class="nrk-table-light" [ngStyle]="{'width':'100%'}">
                <thead>
                  <tr [ngStyle]="{ 'font-size': highlight ? '1rem' : (coversheet ? '0.8rem' : null)  }">
                    <th style="text-align: center">CS #</th>
                    <th style="text-align: center">TC #</th>
                    <th style="text-align: right"># Boxes</th>
                    <th style="text-align: right"># Pieces</th>
                    <th style="text-align: right"># Unit</th>
                    <th style="text-align: center">Type of Carton Box</th>
                    <th style="text-align: right">Net (kg)</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let row of palletInfo[pallet.palId].items">
                    <tr>
                      <td style="text-align: center">{{row.cs}}</td>
                      <td style="text-align: center">{{row.tc}}</td>
                      <td style="text-align: right">{{row.boxes}}</td>
                      <td style="text-align: right">{{row.quantity}}</td>
                      <td style="text-align: right">{{row.unitQuantity}}</td>
                      <td style="text-align: center">
                        <ngx-doc-form-dropdown *ngIf="!print; else cbOptsTpl" [(value)]="row.row.typeOfBox" [options]="data.cartonBoxOptions" [disabled]="pallet.packingType !== 'manual' || isDisabled()"></ngx-doc-form-dropdown>
                        <ng-template #cbOptsTpl>{{data.getOptionName(data.cartonBoxOptions, row.row.typeOfBox)}}</ng-template>
                      </td>
                      <td style="text-align: right">{{row.netWeight}}</td>
                      <td></td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
    
              <div style="height:1rem;">
              </div>

              <table *ngIf="coversheet" style="border: 1pt solid lightgray;padding:0.5rem;margin-bottom:2rem;width:100%;page-break-inside: avoid;">

                <tr><td colspan="2" style="text-align:center">

                  <!-- <div *ngIf="getPacking(pallet)?.boxesPerLayer">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    {{ getPacking(pallet)?.boxesPerLayer }} boxes per layer
                  </div>
                  <div *ngIf="getPacking(pallet)?.layersPerPallet">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    {{ getPacking(pallet)?.layersPerPallet }} layers per pallet
                  </div> -->
                  <div *ngIf="compilation.packingConditions?.length && !compilation.useOldPackingConditions && item.finishedProduct?.type === productType.Energy && getTotalSumPieces(lidx) !== item.quantity" class="ml-4" style="background-color: #f66; padding:0.3rem;text-align:center">
                    <span><b>Different Q on line item and Packing details! Inform Nippon Rika Admin</b></span>
                  </div>
                  <div *ngIf="getPacking(pallet)?.boxesPerLayer && getPacking(pallet)?.layersPerPallet" style="padding:1rem;">
                    <span>Max load per pallet: {{ getPacking(pallet)?.boxesPerLayer }} boxes per layer, {{ getPacking(pallet)?.layersPerPallet }} layers per pallet
                      = max {{getPacking(pallet)?.boxesPerLayer * getPacking(pallet)?.layersPerPallet}} boxes
                    </span>
                  </div>

                </td></tr><tr><td>

                  <div *ngIf="getPacking(pallet)?.outsideLabel">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Print second set of Box labels
                  </div>
                  <div *ngIf="pallet.packingType || getPacking(pallet)?.temperatureSticker">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    PalletType:
                    <ng-container *ngIf="'P0' === pallet.palletType; else p4">
                      no pallet
                    </ng-container>
                    <ng-template #p4>
                      <ng-container *ngIf="!['P4', 'P9'].includes(pallet.palletType); else pother"><b>{{data.getOptionName(data.palletTypeOptions, pallet.palletType)}}</b></ng-container>
                    </ng-template>
                    <ng-template #pother>
                      {{data.getOptionName(data.palletTypeOptions, pallet.palletType)}}
                    </ng-template>
                  </div>

                  <table style="margin-top:0.5rem; padding-top:0.5rem; border-top: 1pt solid #ddd; border-bottom: 1pt solid #eee;">
                    <thead>
                      <tr><td colspan="6" style="height:0.2rem"></td></tr>
                      <tr [ngStyle]="{ 'font-size': '0.8rem'  }">
                        <th></th>
                        <th style="text-align: center">CS #</th>
                        <th style="text-align: center">TC #</th>
                        <th style="text-align: right"># Boxes</th>
                        <th style="text-align: center">Type of Carton Box</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let row of palletInfo[pallet.palId].items">
                        <tr>
                          <td style="font-size:2rem;position:relative;top:0.4rem;padding-left:0">☐</td>
                          <td style="text-align: center">{{row.cs}}</td>
                          <td style="text-align: center">{{row.tc}}</td>
                          <td style="text-align: right">{{row.boxes}}</td>
                          <td style="text-align: center">{{data.getOptionName(data.cartonBoxOptions, row.row.typeOfBox)}}</td>
                          <td></td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>

                  <div *ngIf="getSumBoxes(pallet) && getPacking(pallet)?.boxesPerLayer && getPacking(pallet)?.layersPerPallet">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    # of boxes on this pallet: <b>{{ getSumBoxes(pallet) }}</b>
                    <span>{{getPacking(pallet)?.boxesPerLayer * getPacking(pallet)?.layersPerPallet == getSumBoxes(pallet) ? '(full)' : '(not full)'}}</span>
                  </div>
                  <div>
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Weigh pallet
                  </div>
                  <div *ngIf="spoCustomerRefMismatch[lidx]?.length || pallet.relabelling || this.getPacking(pallet)?.relabelling">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Box label
                  </div>
                  <div *ngIf="getPacking(pallet)?.outsideLabel">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Attach Box labels together with Pallett labels
                  </div>
                  <div>
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Attach inside pallet label
                  </div>
                  <div *ngIf="pallet.temperatureSticker || getPacking(pallet)?.temperatureSticker">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Thermo sticker
                  </div>
                  <div>
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Take photos; Box ID, TS
                  </div>
                  <div *ngIf="pallet.thermoShield || getPacking(pallet)?.thermoShield">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Thermo cover
                  </div>
                  <div>
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Stretch foil
                  </div>
                  <div>
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Mark pallet: DN# & Pal X/Y
                  </div>
                  <div *ngIf="pallet.edgeProtection || getPacking(pallet)?.edgeProtection">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Stack protection
                  </div>
                  <!-- <div>
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Weigh pallet gross weight and enter value
                  </div> -->
                  <!-- <div>
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Pallet label
                  </div> -->
                  <!-- <div *ngIf="pallet.thermoShield || getPacking(pallet)?.thermoShield">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Thermo cover. Apply 2nd pallet label inside and outside
                  </div> -->
                  <!-- <div *ngIf="pallet.edgeProtection || getPacking(pallet)?.edgeProtection">
                    <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
                    Edge protection
                  </div> -->
                  <div style="margin-top:1.3rem">
                    <!-- <span style="font-size:2rem">☐ </span> -->
                    {{pallet.freeText || getPacking(pallet)?.freeText}}
                  </div>

                </td><td>

                  <div style="width:65mm;height:40mm;display:table;place-items:center;border: 2pt dotted #999;text-align:center">
                    <div style="display:table-cell;vertical-align:middle;font-size:1.5rem;color:#999">gross weight in kg</div>
                  </div>

                </td></tr>

              </table>
    
            </div>

          </ng-container> 
        </ng-container>
  
        <div *ngIf="!print">
          <hr>
        </div>

      </ng-container>
    </ng-container>
    
    <div style="page-break-inside:avoid;">
      <div *ngIf="coversheet" style="border: 2pt solid lightgray;padding:0.5rem;margin-top:1rem">
        <div>
          <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
          Attach DN
        </div>
        <div>
          <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
          Attach TC
        </div>
        <div>
          <span style="font-size:2rem;position:relative;top:0.4rem">☐ </span>
          Take photo(s) of complete delivery as it is ready for dispatch
        </div>
      </div>
      <div *ngIf="coversheet && compilation.packingConditions?.[0]?.warehousingInstructions" style="border: 2pt solid lightgray;padding:0.5rem;margin-top:1rem;white-space:pre-wrap;">
        <p><b>Instructions</b></p>{{compilation.packingConditions[0].warehousingInstructions}}
      </div>
      <div *ngIf="coversheet" style="margin-top:5rem;text-align:center">
        <div>____________________________________________________________________________________</div>
        <div>Date           -            Signature</div>
      </div>
    </div>

    <ng-container *ngIf="!print || (compilation.showPackingSummaryInPdf && !highlight && !coversheet)">

      <div style="padding-bottom:0.3rem;">Pallet Summary 
        <div *ngIf="!print" style="display:inline-block;padding-left:3rem;padding-top:1rem;">
          <ngx-doc-form-checkbox [(value)]="compilation.showPackingSummaryInPdf" label="show in PDF" [disabled]="true"></ngx-doc-form-checkbox>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="palletInfoTemplate; context: {}"></ng-container>

    </ng-container>

    <div *ngIf="!print">
      <div class="mt-3 mb-3">TC &harr; SPO Mapping
        <table class="nrk-table">
          <tr>
            <th>TC</th>
            <th>SPO</th>
          </tr>
          <tr *ngFor="let map of data.tcSpoMap">
            <td>{{map.tc}}</td>
            <td>{{map.spo}}</td>
          </tr>
        </table>
      </div>
      <div class="mt-3 mb-3">Warehouse Instructions
        <ngx-form-text [multiline]="1" [value]="compilation.packingConditions?.[0]?.warehousingInstructions" (valueChange)="compilation.packingConditions[0].warehousingInstructions = $event" [disabled]="disabled || !compilation?.packingConditions?.[0]"></ngx-form-text>
      </div>
    </div>

    <div *ngIf="!print"><button class="nrk-button mt-3 mb-2" (click)="recalc()">Recalc</button></div>
    <div *ngIf="!print"><button class="nrk-button mb-2" (click)="copyToClipboard()">Copy to Clipboard</button></div>

    <!-- <div style="height:1rem;">
    </div> -->

  </div>

</ng-container>


<ng-template #palletInfoTemplate let-pal="pallet">

  <table class="nrk-table" [ngStyle]="{'width':'100%'}">
    <thead>
      <tr [ngStyle]="{ 'font-size': highlight ? '1rem' : (coversheet ? '0.8rem' : null)  }">
        <!-- <th style="text-align: center">Pallet #</th> -->
        <th style="text-align: center">Pallet ID</th>
        <th style="text-align: center">Pallet Type</th>
        <th style="text-align: center">Collie Dimensions</th>
        <th style="text-align: center">DN & Pos</th>
        <th style="text-align: right"># Boxes</th>
        <th style="text-align: right">Net Weight (kg)</th>
        <th *ngIf="!print && pal === undefined" style="text-align: center">Gross Override</th>
        <th style="text-align: right">{{ (!print && !isDisabled() && pal === undefined) || coversheet ? 'Calc Gross (kg)' : 'Gross Weight (kg)' }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let pallet of compilation.packingConditions">
        <tr *ngIf="palletInfo[pallet.palId] && (pal === undefined || pallet === pal)">
          <!-- <td style="text-align: center">{{palletInfo[pallet.palId].pos}}</td> -->
          <td style="text-align: center">{{palletInfo[pallet.palId].id}}</td>
          <td style="text-align: center">
            <ngx-doc-form-dropdown *ngIf="!print && pal !== undefined; else typeOptsTpl" class="fullwidth" [(value)]="pallet.palletType" [options]="data.palletTypeOptions" [disabled]="pallet.packingType !== 'manual' || isDisabled()"></ngx-doc-form-dropdown>
            <ng-template #typeOptsTpl>{{pallet.palletType === 'P0' ? 'no pallet' : data.getOptionName(data.palletTypeOptions, pallet.palletType)}}</ng-template>
          </td>
          <td style="text-align: center">{{palletInfo[pallet.palId].dimensions}}</td>
          <td style="text-align: center">{{palletInfo[pallet.palId].dn}}</td>
          <td style="text-align: right">{{palletInfo[pallet.palId].boxes}}</td>
          <td style="text-align: right">{{palletInfo[pallet.palId].netWeight}}</td>
          <td *ngIf="!print && pal === undefined" style="text-align: center">
            <ngx-doc-form-texfield [mode]="'integer'" [styles]="{'width':'5rem'}" [value]="palletInfo[pallet.palId].pal.weightOverride | number:'1.0-0':'de'" (valueChange)="summaryGrossWeightChanged(palletInfo[pallet.palId], $event)" [disabled]="isDisabled()"></ngx-doc-form-texfield>
          </td>
          <td style="text-align: right">
            <div *ngIf="!coversheet">{{palletInfo[pallet.palId].grossWeight}}</div>
            <div *ngIf="coversheet && pallet?.weight" style="color:#999">{{(pallet.weight | ngxRound : 0 : true) || ''}}</div>
          </td>
          <td></td>
        </tr>
      </ng-container>
      <tr *ngIf="pal === undefined && !highlight && !coversheet">
        <td [attr.colspan]="!print ? 9 : 8">
          <ng-container *ngTemplateOutlet="sumTemplate; context: {}"></ng-container>
        </td>
      </tr>
    </tbody>
  </table>

</ng-template>


<ng-template #sumTemplate>
  <div style="text-align: center">
      <b>Σ Boxes:<span style="padding-left:1rem">{{getTotalSumBoxes()}}</span></b>
      <b style="padding-left:3rem">Σ pieces:<span style="padding-left:1rem">{{getTotalSumPieces()}}</span></b>
      <b style="padding-left:3rem">Total Net Weight:<span style="padding-left:1rem;">{{totalNetWeight | ngxRound}} kg </span></b>
      <b style="padding-left:3rem">Total Gross Weight:</b><b style="padding-left:1rem;">{{totalGrossWeight | ngxRound}} kg </b>
  </div>
</ng-template>


<!-- legacy -->
<!-- <ng-container *ngIf="compilation.packingConditions.length && !compilation.packingConditions[0].items"> -->
<ng-container *ngIf="legacy">

  <div #packingTable  *ngIf="checkValid()" [ngStyle]="!compilation.useOldPackingConditions && { 'opacity' : '0.4'}">
    <table class="packing-table">
      <thead *ngIf="!print || (compilation.packingConditions.length)">
        <tr>
          <th *ngIf="!print"><button *ngIf="!disabled" class="nrk-doc-button" (click)="addPallet(0)">+</button></th>
          <th style="text-align:center">Collie</th>
          <th>Pal #</th>
          <th>C/S #</th>
          <th>TC #</th>
          <th>Pallet type (cm)</th>
          <th># of boxes</th>
          <th>Type of carton box (cm)</th>
          <th>Total collie dimension (cm)</th>
          <th style="text-align:right;padding-right:1em">Gross weight (kg)</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="!print">
          <tr *ngFor="let item of compilation.packingConditions; index as idx">
            <td><button *ngIf="!disabled" class="nrk-doc-button" (click)="removePallet(item)">-</button></td>
            <td class="text-center">{{idx+1}}</td>
            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Pal #" [(value)]="$any(item).palNr" [disabled]="disabled"></ngx-doc-form-texfield></td>
            <td><ngx-doc-form-texfield class="fullwidth" placeholder="C/S #" [(value)]="$any(item).csNr" [disabled]="disabled"></ngx-doc-form-texfield></td>
            <td><ngx-doc-form-texfield class="fullwidth" placeholder="TC #" [(value)]="$any(item).tcNr" [disabled]="disabled"></ngx-doc-form-texfield></td>
            <td><ngx-doc-form-dropdown [(value)]="item.palettType" [options]="data.palletTypeOptions" [disabled]="disabled"></ngx-doc-form-dropdown></td>
            <td><ngx-doc-form-texfield class="fullwidth" placeholder="# of carton boxes" [(value)]="$any(item).numberOfBoxes" [disabled]="disabled"></ngx-doc-form-texfield></td>
            <td><ngx-doc-form-dropdown [(value)]="item.typeOfBox" [options]="data.cartonBoxOptions" [disabled]="disabled"></ngx-doc-form-dropdown></td>
            <td><ngx-doc-form-texfield class="fullwidth" placeholder="Total Collie Dimension (cm)" [(value)]="item.dimensions" [disabled]="disabled"></ngx-doc-form-texfield></td>
            <td><ngx-doc-form-texfield class="fullwidth right" placeholder="Gross weight (kg)" [(value)]="$any(item).weight" [disabled]="disabled"></ngx-doc-form-texfield></td>
          </tr>
        </ng-container>
        <ng-container *ngIf="print">
          <tr *ngFor="let item of compilation.packingConditions; index as idx">
            <td style="text-align:center">{{idx+1}}</td>
            <td>{{item.palNr}}</td>
            <td>{{item.csNr}}</td>
            <td>{{item.tcNr}}</td>
            <td>{{data.getOptionName(data.palletTypeOptions, item.palettType)}}</td>
            <td style="text-align:center">{{item.numberOfBoxes}}</td>
            <td>{{data.getOptionName(data.cartonBoxOptions, item.typeOfBox)}}</td>
            <td>{{item.dimensions}}</td>
            <td style="text-align:right;padding-right:2em">{{item.weight | number:'1.2-2':'de'}}</td>
          </tr>
        </ng-container>
        <tr><td *ngIf="!print" [attr.colspan]="10">
          <ngx-form-text style="text-align:right" [(value)]="compilation.packingText" [multiline]="1" class="fullwidth" placeholder="Packing text"  [disabled]="disabled"></ngx-form-text>
        </td></tr>
        <tr><td *ngIf="print && compilation.packingText?.length" [attr.colspan]="9" style="text-align:right;padding: 1em 2em;border:none">
          <span style="white-space:pre-wrap;">{{compilation.packingText}}</span>
        </td></tr>
        <tr *ngIf="grossWeight > 0">
          <td [attr.colspan]="print ? 8 : 9" style="text-align:right;border:none"><b>Total gross weight:</b></td>
          <td style="text-align:right;padding-right:2em;border:none"><b>{{grossWeight | number:'1.2-2':'de'}}</b></td>
        </tr>
        <tr *ngIf="+compilation.netWeight > 0 && (compilation.showNetWeight || !print)">
          <td [attr.colspan]="print ? 8 : 9" style="text-align:right;border:none">
            <input *ngIf="!print" style="margin-right:1em" type="checkbox" [(ngModel)]="compilation.showNetWeight" [disabled]="false" />Total net weight:
          </td>
          <td style="text-align:right;padding-right:2em;border:none">{{compilation.netWeight | number:'1.2-2':'de'}}</td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!print" style="position:relative;bottom:2em;left:1em;width:12em"><button class="nrk-button" (click)="copyToClipboard()">copy to clipboard</button></div>
  </div>
  <div *ngIf="!checkValid()">
    <ngx-doc-form-textarea class="fullwidth" placeholder="Packing" [(value)]="$any(compilation).packingConditions" [disabled]="disabled"></ngx-doc-form-textarea>
  </div>

</ng-container>